import axios from 'axios';
import { decrypt } from './crypto';
import { IDebt } from '../context/Payments';

export default async function creditCardPayment(dataEncrypted: any) {
  try {
    const data = JSON.parse(decrypt(dataEncrypted));

    const {
      cardName,
      cpf,
      cep,
      address,
      addressNumber,
      addressObs,
      neighborhood,
      uf,
      city,
      installment,
      cupom,
      email,
      telephone,
      ipvaSelected,
      licenciamentoSelected,
      dpvatSelected,
      multasSelected,
      outrosSelected,
      consultCode,
      sub,
      mercadoPago,
      encrypted,
    } = data;

    if (!consultCode) {
      throw new Error('Código de consulta invalido');
    }

    const debitos: { codigo: number; valor: number }[] = [];

    if (ipvaSelected.length) {
      ipvaSelected.map((i: IDebt) => {
        const debito = {
          codigo: i.codigo,
          valor: i.valor,
        };
        debitos.push(debito);
      });
    }

    if (licenciamentoSelected.length) {
      licenciamentoSelected.map((i: IDebt) => {
        const debito = {
          codigo: i.codigo,
          valor: i.valor,
        };
        debitos.push(debito);
      });
    }

    if (dpvatSelected.length) {
      dpvatSelected.map((i: IDebt) => {
        const debito = {
          codigo: i.codigo,
          valor: i.valor,
        };
        debitos.push(debito);
      });
    }

    if (multasSelected.length) {
      multasSelected.map((i: IDebt) => {
        const debito = {
          codigo: i.codigo,
          valor: i.valor,
        };
        debitos.push(debito);
      });
    }

    if (outrosSelected.length) {
      outrosSelected.map((i: IDebt) => {
        const debito = {
          codigo: i.codigo,
          valor: i.valor,
        };
        debitos.push(debito);
      });
    }

    const body = {
      payloadCaptura: {
        tipo: 'C',
        parcelas: installment.month,
        valor: installment.totalPrice,
        cupom: cupom,
        debitos: debitos,
        cartoes: [
          {
            encriptado: encrypted,
            valor: installment.totalPrice,
            titular: {
              nome: cardName,
              cpf: cpf.replace(/\D/g, ''),
              email: email,
              telefone: telephone.replace(/\D/g, ''),
              cep: cep.replace(/\D/g, ''),
              logradouro: address,
              numero: addressNumber,
              complemento: addressObs,
              bairro: neighborhood,
              codIbge: '13',
              municipio: city,
              estado: uf,
            },
          },
        ],
        comportamento: {
          konduto: sub,
          clearsale: '',
          analytics: 'string',
          mercadoPago,
        },
      },
    };

    const payment = await axios.post(
      process.env.REACT_APP_LAMBDA_COMUNIX_CAPTURE_CARD!,
      body,
      {
        headers: {
          terminal: process.env.REACT_APP_TERMINAL,
          consulta: consultCode,
          'Request-Environment' : 'frotas',
        },
      },
    );

    return payment.data.data;
  } catch (err: any) {
    console.log('PaymentCard - ===> ', err);
    if (err.response?.data?.warning) {
      return { sucesso: false, warning: err.response.data.warning };
    }
    const lambdaMessage =
      err?.response?.data?.message || err?.response?.data?.data?.message;

    const paymentLimit = err?.response?.data?.paymentLimit || undefined;

    const response = {
      codigoPagamento: null,
      mensagem: lambdaMessage,
      sucesso: false,
      data: err.response?.data?.data,
      paymentLimit,
    };
    return response;
  }
}
